// extracted by mini-css-extract-plugin
export default {"full":"_2iaDjzPN"};